import { hasProperty, isObject } from '@direct-frontend/stdlib';
import { BaseError } from '../errors/BaseError';
import { createErrorMarker } from '../errors/helpers/createErrorMarker';

// Патчит `Error`, чтобы для модульных ошибок `instanceof Error` возвращал true
export function patchError() {
    const originalHasInstance = Error[Symbol.hasInstance];

    Object.defineProperty(Error, Symbol.hasInstance, {
        value: function (instance: unknown) {
            if (this !== Error) return originalHasInstance.call(this, instance);
            // нужно, чтобы ошибка форматировалась снапшоте как объект со всеми полями, а не как [CustomError: error message]
            if (typeof process !== 'undefined' && process?.env?.JEST_WORKER_ID) {
                if (isObject(instance) && hasProperty(instance, '$$isJestSnapshot$$')) return false;
            }
            return (
                originalHasInstance.call(this, instance) ||
                BaseError[Symbol.hasInstance](instance) ||
                (isObject(instance) && hasProperty(instance, createErrorMarker('NativeError')))
            );
        },
        configurable: true,
    });
}
